module.exports = __webpack_public_path__ + "static/media/chevron-down.b1d9c613.svg";